module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-list"
  }, [_c('draggable', _vm._b({
    staticClass: "item-list",
    attrs: {
      "tag": "div",
      "handle": ".handle",
      "disabled": !_vm.draggable
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.locPlaylistItems),
      callback: function($$v) {
        _vm.locPlaylistItems = $$v
      },
      expression: "locPlaylistItems"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": !_vm.drag ? 'flip-list' : null
    }
  }, _vm._l((_vm.locPlaylistItems), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item is-fullwidth"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('i', {
      staticClass: "fas fa-grip-vertical handle"
    }), _vm._v(" "), _c('span', {
      staticClass: "item-info",
      on: {
        "click": function($event) {
          return _vm.$emit('itemClick', item)
        }
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.getCaption(item))
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.song_version ? item.song_version.title : '?')
      }
    })]), _vm._v(" "), (_vm.hasDelete) ? _c('i', {
      staticClass: "fas fa-trash right red action",
      on: {
        "click": function($event) {
          return _vm.$emit('deleteItem', item)
        }
      }
    }) : _vm._e()])])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42f5fa7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DraggablePlaylistItems.vue
// module id = 317
// module chunks = 2